/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdminViewAsCompanyRequest,
    AdminViewAsCompanyRequestFromJSON,
    AdminViewAsCompanyRequestToJSON,
} from '../models/AdminViewAsCompanyRequest';
import {
    type ChallengeError,
    ChallengeErrorFromJSON,
    ChallengeErrorToJSON,
} from '../models/ChallengeError';
import {
    type ChallengeRequestRequest,
    ChallengeRequestRequestFromJSON,
    ChallengeRequestRequestToJSON,
} from '../models/ChallengeRequestRequest';
import {
    type ChallengeResponse,
    ChallengeResponseFromJSON,
    ChallengeResponseToJSON,
} from '../models/ChallengeResponse';
import {
    type CreateMobileDeviceRequest,
    CreateMobileDeviceRequestFromJSON,
    CreateMobileDeviceRequestToJSON,
} from '../models/CreateMobileDeviceRequest';
import {
    type LoginViewRequest,
    LoginViewRequestFromJSON,
    LoginViewRequestToJSON,
} from '../models/LoginViewRequest';
import {
    type LoginViewResponse,
    LoginViewResponseFromJSON,
    LoginViewResponseToJSON,
} from '../models/LoginViewResponse';
import {
    type MobileDevice,
    MobileDeviceFromJSON,
    MobileDeviceToJSON,
} from '../models/MobileDevice';
import {
    type MobileDeviceRegisterError,
    MobileDeviceRegisterErrorFromJSON,
    MobileDeviceRegisterErrorToJSON,
} from '../models/MobileDeviceRegisterError';
import {
    type MobileDeviceRegisterResponse,
    MobileDeviceRegisterResponseFromJSON,
    MobileDeviceRegisterResponseToJSON,
} from '../models/MobileDeviceRegisterResponse';
import {
    type MobileDeviceRenewRequestRequest,
    MobileDeviceRenewRequestRequestFromJSON,
    MobileDeviceRenewRequestRequestToJSON,
} from '../models/MobileDeviceRenewRequestRequest';
import {
    type PasswordReset,
    PasswordResetFromJSON,
    PasswordResetToJSON,
} from '../models/PasswordReset';
import {
    type PasswordResetRequest,
    PasswordResetRequestFromJSON,
    PasswordResetRequestToJSON,
} from '../models/PasswordResetRequest';
import {
    type SSOEnabledResponse,
    SSOEnabledResponseFromJSON,
    SSOEnabledResponseToJSON,
} from '../models/SSOEnabledResponse';
import {
    type SSORequiredCheckRequest,
    SSORequiredCheckRequestFromJSON,
    SSORequiredCheckRequestToJSON,
} from '../models/SSORequiredCheckRequest';
import {
    type SSORequiredCheckResponse,
    SSORequiredCheckResponseFromJSON,
    SSORequiredCheckResponseToJSON,
} from '../models/SSORequiredCheckResponse';
import {
    type SecondFactorViewRequest,
    SecondFactorViewRequestFromJSON,
    SecondFactorViewRequestToJSON,
} from '../models/SecondFactorViewRequest';
import {
    type SecondFactorViewResponse,
    SecondFactorViewResponseFromJSON,
    SecondFactorViewResponseToJSON,
} from '../models/SecondFactorViewResponse';
import {
    type TokenError,
    TokenErrorFromJSON,
    TokenErrorToJSON,
} from '../models/TokenError';
import {
    type TokenRequestRequest,
    TokenRequestRequestFromJSON,
    TokenRequestRequestToJSON,
} from '../models/TokenRequestRequest';
import {
    type TokenResponse,
    TokenResponseFromJSON,
    TokenResponseToJSON,
} from '../models/TokenResponse';

export interface Auth2faCreateRequest {
    secondFactorViewRequest: SecondFactorViewRequest;
}

export interface AuthAdminViewAsCompanyCreateRequest {
    adminViewAsCompanyRequest: AdminViewAsCompanyRequest;
}

export interface AuthLoginCreateRequest {
    loginViewRequest: LoginViewRequest;
}

export interface AuthMobileActivateDestroyRequest {
    deviceId: string;
}

export interface AuthMobileActivateListRequest {
    ordering?: string;
}

export interface AuthMobileActivatePartialUpdateRequest {
    deviceId: string;
}

export interface AuthMobileActivateRetrieveRequest {
    deviceId: string;
}

export interface AuthMobileActivateUpdateRequest {
    deviceId: string;
}

export interface AuthMobileChallengeCreateRequest {
    challengeRequestRequest: ChallengeRequestRequest;
}

export interface AuthMobileRegisterCreateRequest {
    createMobileDeviceRequest: CreateMobileDeviceRequest;
}

export interface AuthMobileRenewCreateRequest {
    mobileDeviceRenewRequestRequest: MobileDeviceRenewRequestRequest;
}

export interface AuthMobileTokenCreateRequest {
    tokenRequestRequest: TokenRequestRequest;
}

export interface AuthPasswordResetCreateRequest {
    passwordResetRequest?: PasswordResetRequest;
}

export interface AuthPasswordResetUpdateRequest {
    passwordResetRequest?: PasswordResetRequest;
}

export interface AuthSsoRequiredCreateRequest {
    sSORequiredCheckRequest: SSORequiredCheckRequest;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * Creates request options for auth2faCreate without sending the request
     */
    async auth2faCreateRequestOpts(requestParameters: Auth2faCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['secondFactorViewRequest'] == null) {
            throw new runtime.RequiredError(
                'secondFactorViewRequest',
                'Required parameter "secondFactorViewRequest" was null or undefined when calling auth2faCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/2fa`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecondFactorViewRequestToJSON(requestParameters['secondFactorViewRequest']),
        };
    }

    /**
     * Check if token is valid and returns frontend API key.
     */
    async auth2faCreateRaw(requestParameters: Auth2faCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecondFactorViewResponse>> {
        const requestOptions = await this.auth2faCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecondFactorViewResponseFromJSON(jsonValue));
    }

    /**
     * Check if token is valid and returns frontend API key.
     */
    async auth2faCreate(requestParameters: Auth2faCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecondFactorViewResponse> {
        const response = await this.auth2faCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authAdminViewAsCompanyCreate without sending the request
     */
    async authAdminViewAsCompanyCreateRequestOpts(requestParameters: AuthAdminViewAsCompanyCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminViewAsCompanyRequest'] == null) {
            throw new runtime.RequiredError(
                'adminViewAsCompanyRequest',
                'Required parameter "adminViewAsCompanyRequest" was null or undefined when calling authAdminViewAsCompanyCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/auth/admin-view-as-company`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminViewAsCompanyRequestToJSON(requestParameters['adminViewAsCompanyRequest']),
        };
    }

    /**
     * Create a new user that has view-only access to company data.  Only works if user is a superuser, and it only creates a temporary account.
     */
    async authAdminViewAsCompanyCreateRaw(requestParameters: AuthAdminViewAsCompanyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authAdminViewAsCompanyCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new user that has view-only access to company data.  Only works if user is a superuser, and it only creates a temporary account.
     */
    async authAdminViewAsCompanyCreate(requestParameters: AuthAdminViewAsCompanyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authAdminViewAsCompanyCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authLoginCreate without sending the request
     */
    async authLoginCreateRequestOpts(requestParameters: AuthLoginCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loginViewRequest'] == null) {
            throw new runtime.RequiredError(
                'loginViewRequest',
                'Required parameter "loginViewRequest" was null or undefined when calling authLoginCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/login`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginViewRequestToJSON(requestParameters['loginViewRequest']),
        };
    }

    /**
     * Check if user and email are correct and creates a token for 2nd step authentication.
     */
    async authLoginCreateRaw(requestParameters: AuthLoginCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginViewResponse>> {
        const requestOptions = await this.authLoginCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginViewResponseFromJSON(jsonValue));
    }

    /**
     * Check if user and email are correct and creates a token for 2nd step authentication.
     */
    async authLoginCreate(requestParameters: AuthLoginCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginViewResponse> {
        const response = await this.authLoginCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authLogoutCreate without sending the request
     */
    async authLogoutCreateRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/auth/logout`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Logout user
     */
    async authLogoutCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authLogoutCreateRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Logout user
     */
    async authLogoutCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authLogoutCreateRaw(initOverrides);
    }

    /**
     * Creates request options for authMobileActivateDestroy without sending the request
     */
    async authMobileActivateDestroyRequestOpts(requestParameters: AuthMobileActivateDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling authMobileActivateDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/mobile-activate/{device_id}/`;
        urlPath = urlPath.replace('{device_id}', encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivateDestroyRaw(requestParameters: AuthMobileActivateDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authMobileActivateDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivateDestroy(requestParameters: AuthMobileActivateDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authMobileActivateDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authMobileActivateList without sending the request
     */
    async authMobileActivateListRequestOpts(requestParameters: AuthMobileActivateListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/mobile-activate/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivateListRaw(requestParameters: AuthMobileActivateListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MobileDevice>>> {
        const requestOptions = await this.authMobileActivateListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MobileDeviceFromJSON));
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivateList(requestParameters: AuthMobileActivateListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MobileDevice>> {
        const response = await this.authMobileActivateListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authMobileActivatePartialUpdate without sending the request
     */
    async authMobileActivatePartialUpdateRequestOpts(requestParameters: AuthMobileActivatePartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling authMobileActivatePartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/mobile-activate/{device_id}/`;
        urlPath = urlPath.replace('{device_id}', encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivatePartialUpdateRaw(requestParameters: AuthMobileActivatePartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MobileDevice>> {
        const requestOptions = await this.authMobileActivatePartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MobileDeviceFromJSON(jsonValue));
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivatePartialUpdate(requestParameters: AuthMobileActivatePartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MobileDevice> {
        const response = await this.authMobileActivatePartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authMobileActivateRetrieve without sending the request
     */
    async authMobileActivateRetrieveRequestOpts(requestParameters: AuthMobileActivateRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling authMobileActivateRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/mobile-activate/{device_id}/`;
        urlPath = urlPath.replace('{device_id}', encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivateRetrieveRaw(requestParameters: AuthMobileActivateRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MobileDevice>> {
        const requestOptions = await this.authMobileActivateRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MobileDeviceFromJSON(jsonValue));
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivateRetrieve(requestParameters: AuthMobileActivateRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MobileDevice> {
        const response = await this.authMobileActivateRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authMobileActivateUpdate without sending the request
     */
    async authMobileActivateUpdateRequestOpts(requestParameters: AuthMobileActivateUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling authMobileActivateUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/mobile-activate/{device_id}/`;
        urlPath = urlPath.replace('{device_id}', encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivateUpdateRaw(requestParameters: AuthMobileActivateUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MobileDevice>> {
        const requestOptions = await this.authMobileActivateUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MobileDeviceFromJSON(jsonValue));
    }

    /**
     * Private endpoint used by users to link devices with their accounts.
     */
    async authMobileActivateUpdate(requestParameters: AuthMobileActivateUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MobileDevice> {
        const response = await this.authMobileActivateUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authMobileChallengeCreate without sending the request
     */
    async authMobileChallengeCreateRequestOpts(requestParameters: AuthMobileChallengeCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['challengeRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'challengeRequestRequest',
                'Required parameter "challengeRequestRequest" was null or undefined when calling authMobileChallengeCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/mobile-challenge/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChallengeRequestRequestToJSON(requestParameters['challengeRequestRequest']),
        };
    }

    /**
     * Creates a mobile challenge and stores it on cache, after verifying that the device exists.
     */
    async authMobileChallengeCreateRaw(requestParameters: AuthMobileChallengeCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeResponse>> {
        const requestOptions = await this.authMobileChallengeCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Creates a mobile challenge and stores it on cache, after verifying that the device exists.
     */
    async authMobileChallengeCreate(requestParameters: AuthMobileChallengeCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeResponse> {
        const response = await this.authMobileChallengeCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authMobileLogoutCreate without sending the request
     */
    async authMobileLogoutCreateRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }


        let urlPath = `/api/v1/auth/mobile-logout/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Logs the mobile device out by deleting it, which removes its key and forces re-registration on next login.
     */
    async authMobileLogoutCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authMobileLogoutCreateRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Logs the mobile device out by deleting it, which removes its key and forces re-registration on next login.
     */
    async authMobileLogoutCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authMobileLogoutCreateRaw(initOverrides);
    }

    /**
     * Creates request options for authMobileRegisterCreate without sending the request
     */
    async authMobileRegisterCreateRequestOpts(requestParameters: AuthMobileRegisterCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createMobileDeviceRequest'] == null) {
            throw new runtime.RequiredError(
                'createMobileDeviceRequest',
                'Required parameter "createMobileDeviceRequest" was null or undefined when calling authMobileRegisterCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/mobile-register/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMobileDeviceRequestToJSON(requestParameters['createMobileDeviceRequest']),
        };
    }

    /**
     * Validates data + saves mobile token.
     */
    async authMobileRegisterCreateRaw(requestParameters: AuthMobileRegisterCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MobileDeviceRegisterResponse>> {
        const requestOptions = await this.authMobileRegisterCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MobileDeviceRegisterResponseFromJSON(jsonValue));
    }

    /**
     * Validates data + saves mobile token.
     */
    async authMobileRegisterCreate(requestParameters: AuthMobileRegisterCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MobileDeviceRegisterResponse> {
        const response = await this.authMobileRegisterCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authMobileRenewCreate without sending the request
     */
    async authMobileRenewCreateRequestOpts(requestParameters: AuthMobileRenewCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['mobileDeviceRenewRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'mobileDeviceRenewRequestRequest',
                'Required parameter "mobileDeviceRenewRequestRequest" was null or undefined when calling authMobileRenewCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/mobile-renew/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MobileDeviceRenewRequestRequestToJSON(requestParameters['mobileDeviceRenewRequestRequest']),
        };
    }

    /**
     * Restamps the device authorization window.
     */
    async authMobileRenewCreateRaw(requestParameters: AuthMobileRenewCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authMobileRenewCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Restamps the device authorization window.
     */
    async authMobileRenewCreate(requestParameters: AuthMobileRenewCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authMobileRenewCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authMobileTokenCreate without sending the request
     */
    async authMobileTokenCreateRequestOpts(requestParameters: AuthMobileTokenCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tokenRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'tokenRequestRequest',
                'Required parameter "tokenRequestRequest" was null or undefined when calling authMobileTokenCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/mobile-token/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TokenRequestRequestToJSON(requestParameters['tokenRequestRequest']),
        };
    }

    /**
     * Validates challenge response.  The device needs to exist and the cache key too!
     */
    async authMobileTokenCreateRaw(requestParameters: AuthMobileTokenCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenResponse>> {
        const requestOptions = await this.authMobileTokenCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenResponseFromJSON(jsonValue));
    }

    /**
     * Validates challenge response.  The device needs to exist and the cache key too!
     */
    async authMobileTokenCreate(requestParameters: AuthMobileTokenCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenResponse> {
        const response = await this.authMobileTokenCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authPasswordResetCreate without sending the request
     */
    async authPasswordResetCreateRequestOpts(requestParameters: AuthPasswordResetCreateRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/password-reset/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordResetRequestToJSON(requestParameters['passwordResetRequest']),
        };
    }

    /**
     * Endpoint to create a password reset request and trigger email to user.
     */
    async authPasswordResetCreateRaw(requestParameters: AuthPasswordResetCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PasswordReset>> {
        const requestOptions = await this.authPasswordResetCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordResetFromJSON(jsonValue));
    }

    /**
     * Endpoint to create a password reset request and trigger email to user.
     */
    async authPasswordResetCreate(requestParameters: AuthPasswordResetCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PasswordReset> {
        const response = await this.authPasswordResetCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authPasswordResetUpdate without sending the request
     */
    async authPasswordResetUpdateRequestOpts(requestParameters: AuthPasswordResetUpdateRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/password-reset/`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordResetRequestToJSON(requestParameters['passwordResetRequest']),
        };
    }

    /**
     * Endpoint to change user password after password reset.
     */
    async authPasswordResetUpdateRaw(requestParameters: AuthPasswordResetUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PasswordReset>> {
        const requestOptions = await this.authPasswordResetUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordResetFromJSON(jsonValue));
    }

    /**
     * Endpoint to change user password after password reset.
     */
    async authPasswordResetUpdate(requestParameters: AuthPasswordResetUpdateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PasswordReset> {
        const response = await this.authPasswordResetUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authSsoRequiredCreate without sending the request
     */
    async authSsoRequiredCreateRequestOpts(requestParameters: AuthSsoRequiredCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sSORequiredCheckRequest'] == null) {
            throw new runtime.RequiredError(
                'sSORequiredCheckRequest',
                'Required parameter "sSORequiredCheckRequest" was null or undefined when calling authSsoRequiredCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/sso-required`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSORequiredCheckRequestToJSON(requestParameters['sSORequiredCheckRequest']),
        };
    }

    /**
     * Check if user email requires SSO check.
     */
    async authSsoRequiredCreateRaw(requestParameters: AuthSsoRequiredCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SSORequiredCheckResponse>> {
        const requestOptions = await this.authSsoRequiredCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SSORequiredCheckResponseFromJSON(jsonValue));
    }

    /**
     * Check if user email requires SSO check.
     */
    async authSsoRequiredCreate(requestParameters: AuthSsoRequiredCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SSORequiredCheckResponse> {
        const response = await this.authSsoRequiredCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authSsoRequiredRetrieve without sending the request
     */
    async authSsoRequiredRetrieveRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/sso-required`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Check if SSO is enabled platform-wide.
     */
    async authSsoRequiredRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SSOEnabledResponse>> {
        const requestOptions = await this.authSsoRequiredRetrieveRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SSOEnabledResponseFromJSON(jsonValue));
    }

    /**
     * Check if SSO is enabled platform-wide.
     */
    async authSsoRequiredRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SSOEnabledResponse> {
        const response = await this.authSsoRequiredRetrieveRaw(initOverrides);
        return await response.value();
    }

}
